import { FacebookIcon } from '@/routes/_app/-components/assets/facebook-icon'
import { LinkedInIcon } from '@/routes/_app/-components/assets/linkedin-icon'
import { TwitterIcon } from '@/routes/_app/-components/assets/twitter-icon'
import { LanguageSelector } from '@/routes/_app/-components/language-selector'
import { Button } from '@/components/ui/button'
import { openCookiePreferences } from '@/lib/cookie-consent'
import { useLingui } from '@lingui/react/macro'
import { Link } from '@tanstack/react-router'

export function Footer() {
  const { t } = useLingui()

  return (
    <footer className="text-muted-foreground text-sm">
      <div className="mx-auto flex max-w-270 flex-wrap items-center justify-center p-4 md:justify-between">
        <div className="flex flex-wrap items-center">
          <LanguageSelector />

          <a
            href="https://facebook.com/danchiano"
            target="_blank"
            rel="noopener noreferrer"
            title="Facebook"
            className="p-4"
          >
            <FacebookIcon />
          </a>
          <a
            href="https://twitter.com/danchiano"
            target="_blank"
            rel="noopener noreferrer"
            title="Twitter"
            className="p-4"
          >
            <TwitterIcon />
          </a>
          <a
            href="https://linkedin.com/company/d'anchiano"
            target="_blank"
            rel="noopener noreferrer"
            title="LinkedIn"
            className="p-4"
          >
            <LinkedInIcon />
          </a>
        </div>

        <Link to="/privacy-policy" className="ml-auto p-4">
          {t`Privacy Policy`}
        </Link>
        <Link to="/terms-of-use" className="p-4">{t`Terms of use`}</Link>
        <Link to="/cookies-policy" className="p-4">{t`Cookies Policy`}</Link>
        {/* The way back to a consent choice from anywhere — and the reason the banner itself can be kept
            off the policy pages, where it would cover the text it is asking about. See
            `useBannerFreeRoute`. `Button` rather than a raw element for the hydration gate: it dispatches
            an event only `CookieBanner` (client-only) listens for, so a pre-hydration click has nothing to
            reach. Styled down to sit level with the links beside it. */}
        <Button
          variant="link"
          className="text-muted-foreground h-auto p-4 font-normal hover:underline"
          onClick={openCookiePreferences}
        >
          {t`Cookie settings`}
        </Button>
      </div>
    </footer>
  )
}
